<template>
  <c-header with-subheader>
    <c-toggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <c-toggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <c-header-brand class="mx-auto d-lg-none" to="/">
      <img
        class="c-sidebar-brand-minimized"
        src="img/logos/koalaboss-body-icon.svg"
        alt="KoalaBoss"
        style="height: 35px; width: auto; position:absolute; left: 60px"
      />
    </c-header-brand>
    <c-header-nav class="d-md-down-none mr-auto">
      <c-header-nav-item class="px-3">
        <search-all />
      </c-header-nav-item>

      <!--      <CHeaderNavItem class="px-3">-->
      <!--        <CHeaderNavLink to="/dashboard">-->
      <!--          Dashboard-->
      <!--        </CHeaderNavLink>-->
      <!--      </CHeaderNavItem>-->
      <!--      <CHeaderNavItem class="px-3">-->
      <!--        <CHeaderNavLink to="/users" exact>-->
      <!--          Users-->
      <!--        </CHeaderNavLink>-->
      <!--      </CHeaderNavItem>-->
      <!--      <CHeaderNavItem class="px-3">-->
      <!--        <CHeaderNavLink>-->
      <!--          Settings-->
      <!--        </CHeaderNavLink>-->
      <!--      </CHeaderNavItem>-->
    </c-header-nav>
    <c-header-nav>
      <c-header-nav-item class="px-3">
        <button class="c-header-nav-btn" @click="setDarkMode">
          <c-icon v-if="$store.state.darkMode" name="cil-sun" />
          <c-icon v-else name="cil-moon" />
        </button>
      </c-header-nav-item>
      <!--      <TheHeaderDropdownNotif/>-->
      <!--      <TheHeaderDropdownTasks/>-->
      <!--      <TheHeaderDropdownMssgs/>-->
      <the-header-dropdown-accnt />
      <c-header-nav-item class="px-3">
        <button in-header class="c-header-nav-btn" @click="setShowAside">
          <c-icon size="lg" name="cil-applications-settings" class="mr-2" />
        </button>
      </c-header-nav-item>
    </c-header-nav>

    <c-subheader class="px-3">
      <c-breadcrumb-router class="border-0 mb-0" />
    </c-subheader>
  </c-header>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt';
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif';
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks';
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs';
import SearchAll from '../views/components/search/SearchAll';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs,
    SearchAll,
  },
  methods: {
    setDarkMode() {
      const currentSetting = this.$store.state.darkMode;
      this.$store.commit('toggle', 'darkMode');
      // Save to user
      const data = {
        preferenceKey: 'darkMode',
        preferenceValue: !currentSetting,
      };
      this.$http.put(buildEndpoint('account/preferences/save'), data);
    },
    setShowAside() {
      const currentSetting = this.$store.state.asideShow;
      this.$store.commit('toggle', 'asideShow');
      // Save to user
      const data = {
        preferenceKey: 'asideShow',
        preferenceValue: !currentSetting,
      };
      this.$http.put(buildEndpoint('account/preferences/save'), data);
    },
  },
};
</script>
